import React from "react";
import PropTypes from "prop-types";
import AppTableContainer from "../../../../@crema/core/AppTableContainer";

function SearchContextTable({ data }) {
  const columns = [
    {
      title: "Search String",
      dataIndex: "searchString",
      key: "searchString",
      ellipsis: true,
    },
  ];
  return (
    <AppTableContainer
      className="customer-table"
      hoverColor
      data={data}
      columns={columns}
      scroll={{ x: "auto" }}
    />
  );
}

export default SearchContextTable;

SearchContextTable.defaultProps = {
  data: [],
};
SearchContextTable.propTypes = {
  data: PropTypes.array,
};
